import api from '@/utils/api'

export default {
    uploadFile(formData) {
        return api.uploadFile(`uploads/assets`, formData)
    }
}
